export const QUERY_REFETCH_FAST = 1000 * 60 * 5;
